import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { PHONE, PHONE_LINK } from "../data";

const LINKS = [
  { label: "Menu", href: "#menu" },
  { label: "Cleanses", href: "#cleanses" },
  { label: "Story", href: "#story" },
  { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-leaf/10 bg-cream/70 backdrop-blur-xl">
      <nav className="mx-auto flex max-w-[1440px] items-center justify-between px-6 py-4 md:px-10">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2">
          <img src="/images/logo.png" alt="Main Squeeze logo" className="h-11 w-11 rounded-full object-cover" />
          <span className="font-cursive text-3xl font-bold text-leaf">Main Squeeze</span>
        </a>

        <div className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[11px] font-medium uppercase tracking-[0.25em] text-leaf/70 transition-colors duration-300 hover:text-melon"
            >
              {l.label}
            </a>
          ))}
          <a
            href={PHONE_LINK}
            data-testid="nav-phone-button"
            className="flex items-center gap-2 rounded-full bg-leaf px-5 py-2.5 text-xs font-medium tracking-wide text-cream transition-[background-color,transform] duration-300 hover:scale-95 hover:bg-melon"
          >
            <Phone className="h-3.5 w-3.5" />
            {PHONE}
          </a>
        </div>

        <button
          data-testid="mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="text-leaf lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-leaf/10 bg-cream/95 backdrop-blur-xl lg:hidden"
          >
            <div className="flex flex-col gap-1 px-6 py-6">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                  onClick={() => setOpen(false)}
                  className="py-3 font-serif text-3xl text-leaf transition-colors duration-300 hover:text-melon"
                >
                  {l.label}
                </a>
              ))}
              <a
                href={PHONE_LINK}
                data-testid="mobile-nav-phone-button"
                className="mt-4 flex w-fit items-center gap-2 rounded-full bg-leaf px-6 py-3 text-sm text-cream"
              >
                <Phone className="h-4 w-4" />
                {PHONE}
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
